/** Zone codes are typed with erratic spacing: `AT-H-4`, `AT - H - 4`, `AT -H- 4`. */
export function stripWhitespace(text: string): string {
  return text.replace(/\s+/g, '');
}

/** Notion-coded names start `AT - …`. Uppercase only, by product decision. */
const ZONE_CODE_PREFIX = /^[A-Z]{2}-/;

/** Gates the zone suggestions: below the country code and its dash, none show. */
export function isZoneCodePrefix(query: string): boolean {
  return ZONE_CODE_PREFIX.test(stripWhitespace(query));
}
